document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const headerHeight = header.offsetHeight;

  function handleSticky() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > headerHeight) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  }

  // On load (fix F5)
  handleSticky();

  // On scroll
  window.addEventListener('scroll', handleSticky);
});